// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2ZHup","rootSuccess":"CompleteLink_rootSuccess__2Hpxo","rootFailure":"CompleteLink_rootFailure__2YaiK","isDisabled":"CompleteLink_isDisabled__3e5Ow"};